<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1 class="fs-2">Amature Badminton tournament </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <!-- <div class="sec-title text-center">
            <h2><span>RAISONI FOUNDATION PRESENTS YONEX SUNRISE G. H. Raisoni Memorial
                    Nagpur District Summer Amateur Badminton Tournament – 2025</span></h2>
        </div>
        <div class="row justify-content-between">
            <div class="col-md-7">

                <p><strong>Organised by:</strong></p>
                <p>Nagpur District Badminton Association (NDBA) & Raisoni Foundation Sports and Culture</p>
                <p><strong>Dates:</strong> 29th May – 1st June 2025</p>
                <p><strong>Venue:</strong> Subhedar Badminton Hall, RTMNU Campus, Ravi Nagar, Nagpur -440010</p>
                <h6>Events Categories:</h6>

                <h6 class="mt-4">Under-9:</h6>
                <ul class="list-style list-style1 list-count mb-3 ">

                    <li>Boy's Singles</li>
                    <li>Girl's Singles</li>
                </ul>
                <h6 class="mt-4">Under-11:</h6>
                <ul class="list-style list-style1 list-count mb-3 ">

                    <li>Boy's Singles</li>
                    <li>Girl's Singles</li>
                </ul>
                <h6 class="mt-4">Under-13:</h6>
                <ul class="list-style list-style1 list-count mb-3 ">

                    <li>Boy's Singles</li>
                    <li>Girl's Singles</li>
                </ul>
                <h6 class="mt-4">Under-15:</h6>
                <ul class="list-style list-style1 list-count mb-3 ">

                    <li>Boy's Singles</li>
                    <li>Girl's Singles</li>
                </ul>
                <h6 class="mt-4">Under-17:</h6>
                <ul class="list-style list-style1 list-count mb-3 ">

                    <li>Boy's Singles</li>
                    <li>Girl's Singles</li>
                </ul>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/amateur-badminton-tournament.png"
                        alt="GHRSCF" />

                </div>
            </div>
        </div>

        <div class="row ">
            <div class="col-md-12">

                <h6 class="mt-4">Open Categories:</h6>
                <ul class="list-style list-style1 mb-3 list-count">

                    <li>Men’s Singles</li>
                    <li>Women’s Singles</li>
                    <li>Men’s Doubles</li>
                    <li>Women’s Doubles</li>
                    <li>Mixed Doubles</li>
                </ul>
                <h6 class="mt-4">Open Categories:</h6>
                <ul class="list-style list-style1 mb-3 list-count">

                    <li>Men’s Singles (35+)</li>
                    <li>Women’s Singles (35+)</li>
                    <li>Men’s Doubles (35+)</li>
                    <li>Women’s Doubles (35+)</li>
                    <li>Mixed Doubles (35+)</li>
                </ul>
            </div>
            <hr>
            <p>🎯 Total Prize Pool: ₹84,000/-</p>
            <p>📝 Last Date for Entry & Withdrawal:
                26th May 2025</p>
            <h6 class="mt-4">Under-17:</h6>
            <ul class="list-style list-style1 list-count mb-3 ">

                <li>Only online entries through ndba.co.in will be accepted.</li>
                <li>No offline entries will be entertained.</li>
            </ul>
            <p>📞For Queries, contact:</p>
            <P><strong>Smt. Madhavi Hedaoo</strong> - +91 7769020945</P>
            <P><strong>Aditya Galande</strong> - +91 9545202833</P>
            <P><strong>Nishad Choure</strong> - +91 7498102314</P>
        </div>

        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-8.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-8.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-8.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-9.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-9.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-9.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                alt="GHRSCF" />
                        </div>
                    </a>
                </li>
            </ul>
        </div> -->
        <ul class="nav nav-pills justify-content-center flex-row" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link text-center active" id="cultural-tab" data-bs-toggle="tab" href="#cultural"
                    role="tab" aria-controls="cultural" aria-selected="true">2026</a>
            </li>
            <li class="nav-item">

                <a class="nav-link text-center " id="academic-tab" data-bs-toggle="tab" href="#academic" role="tab"
                    aria-controls="academic" aria-selected="false">2025</a>

            </li>
        </ul>
        <div class="tab-content mt-5" id="myTabContent">
            <div class="tab-pane fade show active" id="cultural" role="tabpanel" aria-labelledby="cultural-tab">
                <div class="sec-title text-center mb-5 aos-init aos-animate" data-aos="zoom-in">
                    <h2><span>Amature Badminton tournament</span></h2>
                </div>
                <p>"An exciting celebration of sportsmanship, energy, and competitive spirit.

                    The Amateur Badminton Tournament organised under Raisoni Foundation brought together passionate
                    players for a day filled with thrilling matches, teamwork, and memorable moments on the court.

                    From intense rallies to outstanding performances, the tournament reflected dedication,
                    discipline, and true sporting spirit.

                    A successful event that inspired every participant to play, compete, and grow."</p>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-8.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-pane fade" id="academic" role="tabpanel" aria-labelledby="academic-tab">
                <div class="sec-title text-center">
                    <h2><span>RAISONI FOUNDATION PRESENTS YONEX SUNRISE G. H. Raisoni Memorial
                            Nagpur District Summer Amateur Badminton Tournament – 2025</span></h2>
                </div>
                <div class="row justify-content-between">
                    <div class="col-md-7">

                        <p><strong>Organised by:</strong></p>
                        <p>Nagpur District Badminton Association (NDBA) & Raisoni Foundation Sports and Culture</p>
                        <p><strong>Dates:</strong> 29th May – 1st June 2025</p>
                        <p><strong>Venue:</strong> Subhedar Badminton Hall, RTMNU Campus, Ravi Nagar, Nagpur -440010</p>
                        <h6>Events Categories:</h6>

                        <h6 class="mt-4">Under-9:</h6>
                        <ul class="list-style list-style1 list-count mb-3 ">

                            <li>Boy's Singles</li>
                            <li>Girl's Singles</li>
                        </ul>
                        <h6 class="mt-4">Under-11:</h6>
                        <ul class="list-style list-style1 list-count mb-3 ">

                            <li>Boy's Singles</li>
                            <li>Girl's Singles</li>
                        </ul>
                        <h6 class="mt-4">Under-13:</h6>
                        <ul class="list-style list-style1 list-count mb-3 ">

                            <li>Boy's Singles</li>
                            <li>Girl's Singles</li>
                        </ul>
                        <h6 class="mt-4">Under-15:</h6>
                        <ul class="list-style list-style1 list-count mb-3 ">

                            <li>Boy's Singles</li>
                            <li>Girl's Singles</li>
                        </ul>
                        <h6 class="mt-4">Under-17:</h6>
                        <ul class="list-style list-style1 list-count mb-3 ">

                            <li>Boy's Singles</li>
                            <li>Girl's Singles</li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <div class="image-effect-3">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/amateur-badminton-tournament.png"
                                alt="GHRSCF" />

                        </div>
                    </div>
                </div>

                <div class="row ">
                    <div class="col-md-12">

                        <h6 class="mt-4">Open Categories:</h6>
                        <ul class="list-style list-style1 mb-3 list-count">

                            <li>Men’s Singles</li>
                            <li>Women’s Singles</li>
                            <li>Men’s Doubles</li>
                            <li>Women’s Doubles</li>
                            <li>Mixed Doubles</li>
                        </ul>
                        <h6 class="mt-4">Open Categories:</h6>
                        <ul class="list-style list-style1 mb-3 list-count">

                            <li>Men’s Singles (35+)</li>
                            <li>Women’s Singles (35+)</li>
                            <li>Men’s Doubles (35+)</li>
                            <li>Women’s Doubles (35+)</li>
                            <li>Mixed Doubles (35+)</li>
                        </ul>
                    </div>
                    <hr>
                    <p>🎯 Total Prize Pool: ₹84,000/-</p>
                    <p>📝 Last Date for Entry & Withdrawal:
                        26th May 2025</p>
                    <h6 class="mt-4">Under-17:</h6>
                    <ul class="list-style list-style1 list-count mb-3 ">

                        <li>Only online entries through ndba.co.in will be accepted.</li>
                        <li>No offline entries will be entertained.</li>
                    </ul>
                    <p>📞For Queries, contact:</p>
                    <P><strong>Smt. Madhavi Hedaoo</strong> - +91 7769020945</P>
                    <P><strong>Aditya Galande</strong> - +91 9545202833</P>
                    <P><strong>Nishad Choure</strong> - +91 7498102314</P>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-8.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-9.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-9.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2025/yonex-sunrise-memo-ngp-dist-sum-amateur-badminton-tournament-2025/yonex-sunrise-badminton-turnament-25-9.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
